<div class="admin-card" [class.mt-4]="!removeTopMargin">
  <div class="d-flex justify-content-between align-items-center admin-card__title"
       [class.remove-underline]="!isContentVisible || !showUnderline">
    <span class="text-uppercase fw-bold">{{ cardTitle }}</span>
    <div class="d-flex align-items-center">
      <ng-content select="[slot='trailingWidget']"></ng-content>
      @if (showToggleButton) {
        <button class="btn btn-outline-secondary btn-circle" (click)="toggleCollapse()"
                [class.active-btn]="isContentVisible">
          <i class="fas" [class.fa-chevron-down]="!isContentVisible" [class.fa-chevron-up]="isContentVisible"></i>
        </button>
      }
    </div>
  </div>
  <div [ngbCollapse]="!isContentVisible" [class.pt-3]="isContentVisible">
    <div class="row">
      <div class="col-12">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
